import Spinner from './Spinner'
import SpinnerFlex from './SpinnerFlex'

export default Object.assign(Spinner, {
  Flex: SpinnerFlex,
})
